import { ScaleElement } from '@scale/base-element';

class ScaleDeferredMedia extends ScaleElement {
  setup() {
    const autoplay = this.getBoolean('autoplay');

    if (autoplay) {
      this.#load();
      return;
    }

    const playBtn = this.ref('play');
    if (playBtn) {
      this.on('click', () => this.#load(), { target: playBtn, once: true });
    }
  }

  #load() {
    const template = this.ref('media');
    if (!template || this.hasAttribute('loaded')) return;

    const content = template.content.cloneNode(true);
    template.parentElement.appendChild(content);
    this.setAttribute('loaded', '');
  }
}

if (!customElements.get('scale-deferred-media')) {
  customElements.define('scale-deferred-media', ScaleDeferredMedia);
}
